function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M36 53L37.3471 57.1459H41.7063L38.1796 59.7082L39.5267 63.8541L36 61.2918L32.4733 63.8541L33.8204 59.7082L30.2937 57.1459H34.6529L36 53Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M285 57L286.347 61.1459H290.706L287.18 63.7082L288.527 67.8541L285 65.2918L281.473 67.8541L282.82 63.7082L279.294 61.1459H283.653L285 57Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M291 6L292.347 10.1459H296.706L293.18 12.7082L294.527 16.8541L291 14.2918L287.473 16.8541L288.82 12.7082L285.294 10.1459H289.653L291 6Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M187 0L188.347 4.1459H192.706L189.18 6.7082L190.527 10.8541L187 8.2918L183.473 10.8541L184.82 6.7082L181.294 4.1459H185.653L187 0Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M252 83L253.347 87.1459H257.706L254.18 89.7082L255.527 93.8541L252 91.2918L248.473 93.8541L249.82 89.7082L246.294 87.1459H250.653L252 83Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M249 24L250.347 28.1459H254.706L251.18 30.7082L252.527 34.8541L249 32.2918L245.473 34.8541L246.82 30.7082L243.294 28.1459H247.653L249 24Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M377 18L378.347 22.1459H382.706L379.18 24.7082L380.527 28.8541L377 26.2918L373.473 28.8541L374.82 24.7082L371.294 22.1459H375.653L377 18Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M410 125L411.347 129.146H415.706L412.18 131.708L413.527 135.854L410 133.292L406.473 135.854L407.82 131.708L404.294 129.146H408.653L410 125Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M422 165L423.347 169.146H427.706L424.18 171.708L425.527 175.854L422 173.292L418.473 175.854L419.82 171.708L416.294 169.146H420.653L422 165Z",
  fill: "white"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M387 92L388.347 96.1459H392.706L389.18 98.7082L390.527 102.854L387 100.292L383.473 102.854L384.82 98.7082L381.294 96.1459H385.653L387 92Z",
  fill: "white"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M329 89L330.347 93.1459H334.706L331.18 95.7082L332.527 99.8541L329 97.2918L325.473 99.8541L326.82 95.7082L323.294 93.1459H327.653L329 89Z",
  fill: "white"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M427 35L428.347 39.1459H432.706L429.18 41.7082L430.527 45.8541L427 43.2918L423.473 45.8541L424.82 41.7082L421.294 39.1459H425.653L427 35Z",
  fill: "white"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M364 48L365.347 52.1459H369.706L366.18 54.7082L367.527 58.8541L364 56.2918L360.473 58.8541L361.82 54.7082L358.294 52.1459H362.653L364 48Z",
  fill: "white"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M399 45L400.347 49.1459H404.706L401.18 51.7082L402.527 55.8541L399 53.2918L395.473 55.8541L396.82 51.7082L393.294 49.1459H397.653L399 45Z",
  fill: "white"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M431 81L432.347 85.1459H436.706L433.18 87.7082L434.527 91.8541L431 89.2918L427.473 91.8541L428.82 87.7082L425.294 85.1459H429.653L431 81Z",
  fill: "white"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M329 26L330.347 30.1459H334.706L331.18 32.7082L332.527 36.8541L329 34.2918L325.473 36.8541L326.82 32.7082L323.294 30.1459H327.653L329 26Z",
  fill: "white"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M24 171L25.3471 175.146H29.7063L26.1796 177.708L27.5267 181.854L24 179.292L20.4733 181.854L21.8204 177.708L18.2937 175.146H22.6529L24 171Z",
  fill: "white"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M36 131L37.3471 135.146H41.7063L38.1796 137.708L39.5267 141.854L36 139.292L32.4733 141.854L33.8204 137.708L30.2937 135.146H34.6529L36 131Z",
  fill: "white"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M6 93L7.34708 97.1459H11.7063L8.17963 99.7082L9.52671 103.854L6 101.292L2.47329 103.854L3.82037 99.7082L0.293661 97.1459H4.65292L6 93Z",
  fill: "white"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M67 80L68.3471 84.1459H72.7063L69.1796 86.7082L70.5267 90.8541L67 88.2918L63.4733 90.8541L64.8204 86.7082L61.2937 84.1459H65.6529L67 80Z",
  fill: "white"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M67 35L68.3471 39.1459H72.7063L69.1796 41.7082L70.5267 45.8541L67 43.2918L63.4733 45.8541L64.8204 41.7082L61.2937 39.1459H65.6529L67 35Z",
  fill: "white"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M214 24L215.347 28.1459H219.706L216.18 30.7082L217.527 34.8541L214 32.2918L210.473 34.8541L211.82 30.7082L208.294 28.1459H212.653L214 24Z",
  fill: "white"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M24 18L25.3471 22.1459H29.7063L26.1796 24.7082L27.5267 28.8541L24 26.2918L20.4733 28.8541L21.8204 24.7082L18.2937 22.1459H22.6529L24 18Z",
  fill: "white"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M220 65L221.347 69.1459H225.706L222.18 71.7082L223.527 75.8541L220 73.2918L216.473 75.8541L217.82 71.7082L214.294 69.1459H218.653L220 65Z",
  fill: "white"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M181 87L182.347 91.1459H186.706L183.18 93.7082L184.527 97.8541L181 95.2918L177.473 97.8541L178.82 93.7082L175.294 91.1459H179.653L181 87Z",
  fill: "white"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M160 32L161.347 36.1459H165.706L162.18 38.7082L163.527 42.8541L160 40.2918L156.473 42.8541L157.82 38.7082L154.294 36.1459H158.653L160 32Z",
  fill: "white"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M103 6L104.347 10.1459H108.706L105.18 12.7082L106.527 16.8541L103 14.2918L99.4733 16.8541L100.82 12.7082L97.2937 10.1459H101.653L103 6Z",
  fill: "white"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M134 71L135.347 75.1459H139.706L136.18 77.7082L137.527 81.8541L134 79.2918L130.473 81.8541L131.82 77.7082L128.294 75.1459H132.653L134 71Z",
  fill: "white"
});

var SvgStars = function SvgStars(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 437 183",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStars, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/stars.b581ccad.svg";
export { ForwardRef as ReactComponent };